// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/logos/baloa-logo-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.header-auth {
    background: var(--white-color);
    padding: var(--normal-margin-v) var(--double-margin-h);
    /* box-shadow: var(--shadow); */
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    height: 72px;
    width: 100%;
    z-index: 100;
    top: 0;
}

/* .header-auth-link {
  min-width: calc(var(--space-eighth) * 120)
} */

.header-auth__image {
    height: var(--space-x2);
    vertical-align: middle;
}
.header-auth__search{
    width: 336px;
    float: right;
}

.header-authenticated__left-col {
    display: flex;
    align-items: center;
    gap: 20px;
}

.header-auth__actions {
    display: grid;
    grid-column-gap: 40px;
    display: flex;
    align-items: center;
    justify-self: flex-end;
}

/*.header-auth__actions > div, .header-auth__actions > a {*/
.header-auth__actions > a {
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 0;
    margin: 0;
    flex-direction: column;
    text-align: center;
}
.header-auth__actions:hover > div, .header-auth__actions:hover > a {
    cursor: pointer;
}

.header-auth__actions__new-post {
    background-color: var(--new-green-color);

    display: flex;
    justify-content: center;
    align-content: center;
    padding: 10px;
    margin: 0;
    border-radius: 50%;
    color: var(--white-color);
}

.header-auth__actions__new-post .icon-plus{
    font-size: 20px;
}

.header-auth__actions__me {
    max-width: 47px;
    max-height: 47px;
/*     box-sizing: content-box;
    border-radius: 2px;
    overflow: hidden; */
}
.header-auth__actions__me img {
    width: 100%;
    border-radius: 50%;
}
.header-auth__actions__me .icon-ball {
    font-size: 37px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 47px;
    color: var(--white-color);
}

.header-auth__actions__me__popover {
    padding: var(--space) var(--space);
    border-radius: 14px;
    min-width: 300px;
}
.header-auth__actions__me__popover__action {
    /*margin-bottom: var(--space-half);*/
    width: 100%;
}

.header-auth__actions__home .icon-home{
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header-auth__actions__home.active .icon-home{
    color: var(--new-green-color);
    font-size: 28px;
}

.header-auth__actions__home .icon-trophy{
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header-auth__actions__home.active .icon-trophy{
    color: var(--new-green-color);
    font-size: 28px;
}

.header-auth__actions__home .hubicon-live_tv1{
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header-auth__actions__home.active .hubicon-live_tv-1{
    color: var(--new-green-color);
    font-size: 28px;
}

.header-auth__actions__notifications .icon-bell-59{
    color: var(--basic-gray-color);
    font-size: 28px;
}

.header-auth__actions__notifications {
    text-align: center;
}

.header-auth__actions__home .baloa-username,
.header-auth__actions__notifications .baloa-username {
    font-size: var(--space-half-quarter);
    color: var(--basic-gray-color);
}

.header-auth__actions__home .baloa-username.active {
    color: var(--new-green-color);
}

.header-auth__actions__me__popover__item{
    display: flex;
    align-items: center;
    padding-top: var(--space);
    padding-bottom: var(--space-half);
}
.header-auth__actions__me__popover__item img{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: var(--space);
}
.header-auth__actions__me__popover__item .icon-ball{
    font-size: 26px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 36px;
    color: var(--white-color);
    margin-right: var(--space);
}
.header-auth__actions__me__popover__item .baloa-names{
    color: var(--primary-dark-color);
    
}
.header-auth__actions__me__popover__item .iconb2-exit, .header-auth__actions__me__popover__item .iconb2-settings{
    font-size: 20px;
    color: var(--basic-gray-color);
    margin-right: 10px;
}
.header-auth__separator{
    border-top: 1px solid var(--separator-color);
}

.header-auth__actions__popover_user .MuiPopover-paper {
    right: 30px;
    left: unset !important;
    top: 70px !important;
}

.header-auth__actions__popover_notificaciones .MuiPopover-paper {
    right: 30px;
    left: unset !important;
    top: 70px !important;
}

.header-auth__mobile,
.header-auth__mobile-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-auth__mobile-menu {
    display: flex;
    justify-content: flex-start;
}

.header-auth__mobile {
    position: fixed;
    top: 0;
    background-color: var(--white-color);
    width: 100%;
    padding: 14px 12px;
    z-index: 2;
}

.header-auth__mobile-menu {
    width: 40%;
}

.header-auth__mobile-actions {
    width: 60%;
}

.header-auth__actions__mobile-me img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
}

.header-auth__actions__mobile-new-post {
    background-color: var(--new-green-color);
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 8px;
    margin: 0;
    border-radius: 50%;
    color: var(--white-color);
}

.header-auth__actions__mobile-me {
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-auth__mobile-actions .icon-home,
.header-auth__mobile-actions .icon-trophy,
.header-auth__mobile-actions .icon-bell-59,
.header-auth__mobile-actions .hubicon-live_tv1 {
    font-size: 24px;
    color: var(--basic-gray-color);
}

.header-auth__actions__mobile-home.active .hubicon-live_tv-1 {
    font-size: 24px;
    color: var(--new-green-color);
}

.header-auth__mobile-menu .hubicon-menu {
    font-size: 24px;
    color: var(--primary-very-dark-color);
}

.header-auth__actions__mobile-home {
    display: flex;
    align-items: center;
}

.header-auth__mobile-menu .icon-search {
    font-size: 14px;
    color: #949F9A;
    background-color: var(--new-gray-background-color);
    border-radius: 50%;
    padding: 6px;
    margin-left: var(--space);
    font-weight: bold;
}
.header-auth__mobile__search-box {
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    padding: 14px 16px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 4;
}
.header-auth__mobile__search-box .icon-arrow-left {
    font-size: calc( var(--space) + var(--space-half));
    margin-right: var(--space-and-half);
}
.header-auth__mobile__search-box .search-form__form input[type=text] {
    padding: var(--space-half) var(--space-half) var(--space-half) var(--space-x3)
 }
.header-auth__mobile__search-box .search-form__form .MuiSvgIcon-root {
    margin: calc( var(--space-quarter) + 1px );
}
.header-auth__actions__mobile-home.active .icon-home,
.header-auth__actions__mobile-home.active .icon-trophy {
    color: var(--new-green-color);
}    
.header-auth__actions__mobile-me .icon-ball {
    font-size: 20px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.header-authenticated__baloa-landing {
    background-color: #EAF7F0;
    padding: 12px;
    gap: 8px;
}

@media screen and ( max-width: 576px ) {

    .header-auth__image {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

}


@media screen and (max-width: 768px){

  .header-auth__search {
      width: 24vw !important;
  }

  .header-auth__actions a.header-auth__actions__home  {
      margin-left: 15px !important;
  }

  .header-auth__search form {
      width: 100% !important;
  }

  .header-auth__search .search-form__form{
      margin-left: var(--space-half);
  }

  .header-auth-link {
    min-width: unset;
  }

}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .header-auth__mobile-menu .hubicon-menu {
        margin-top: 2px;
    }

    .header-auth__mobile-menu .icon-search {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header-authenticated/HeaderAuthenticatedComponent.styles.css"],"names":[],"mappings":";;AAEA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,MAAM;AACV;;AAEA;;GAEG;;AAEH;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;;IAExC,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;uBAEuB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,gCAAgC;;AAEpC;AACA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;;IAII,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;AACd;AACA;IACI,kDAAkD;IAClD,mCAAmC;AACvC;AACA;IACI;CACH;AACD;IACI,0CAA0C;AAC9C;AACA;;IAEI,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,QAAQ;AACZ;;AAEA;;IAEI;QACI,gDAAuD;IAC3D;;AAEJ;;;AAGA;;EAEE;MACI,sBAAsB;EAC1B;;EAEA;MACI,4BAA4B;EAChC;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,8BAA8B;EAClC;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\n\n.header-auth {\n    background: var(--white-color);\n    padding: var(--normal-margin-v) var(--double-margin-h);\n    /* box-shadow: var(--shadow); */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: fixed;\n    height: 72px;\n    width: 100%;\n    z-index: 100;\n    top: 0;\n}\n\n/* .header-auth-link {\n  min-width: calc(var(--space-eighth) * 120)\n} */\n\n.header-auth__image {\n    height: var(--space-x2);\n    vertical-align: middle;\n}\n.header-auth__search{\n    width: 336px;\n    float: right;\n}\n\n.header-authenticated__left-col {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.header-auth__actions {\n    display: grid;\n    grid-column-gap: 40px;\n    display: flex;\n    align-items: center;\n    justify-self: flex-end;\n}\n\n/*.header-auth__actions > div, .header-auth__actions > a {*/\n.header-auth__actions > a {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    padding: 0;\n    margin: 0;\n    flex-direction: column;\n    text-align: center;\n}\n.header-auth__actions:hover > div, .header-auth__actions:hover > a {\n    cursor: pointer;\n}\n\n.header-auth__actions__new-post {\n    background-color: var(--new-green-color);\n\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    padding: 10px;\n    margin: 0;\n    border-radius: 50%;\n    color: var(--white-color);\n}\n\n.header-auth__actions__new-post .icon-plus{\n    font-size: 20px;\n}\n\n.header-auth__actions__me {\n    max-width: 47px;\n    max-height: 47px;\n/*     box-sizing: content-box;\n    border-radius: 2px;\n    overflow: hidden; */\n}\n.header-auth__actions__me img {\n    width: 100%;\n    border-radius: 50%;\n}\n.header-auth__actions__me .icon-ball {\n    font-size: 37px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 47px;\n    color: var(--white-color);\n}\n\n.header-auth__actions__me__popover {\n    padding: var(--space) var(--space);\n    border-radius: 14px;\n    min-width: 300px;\n}\n.header-auth__actions__me__popover__action {\n    /*margin-bottom: var(--space-half);*/\n    width: 100%;\n}\n\n.header-auth__actions__home .icon-home{\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__home.active .icon-home{\n    color: var(--new-green-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__home .icon-trophy{\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__home.active .icon-trophy{\n    color: var(--new-green-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__home .hubicon-live_tv1{\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__home.active .hubicon-live_tv-1{\n    color: var(--new-green-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__notifications .icon-bell-59{\n    color: var(--basic-gray-color);\n    font-size: 28px;\n}\n\n.header-auth__actions__notifications {\n    text-align: center;\n}\n\n.header-auth__actions__home .baloa-username,\n.header-auth__actions__notifications .baloa-username {\n    font-size: var(--space-half-quarter);\n    color: var(--basic-gray-color);\n}\n\n.header-auth__actions__home .baloa-username.active {\n    color: var(--new-green-color);\n}\n\n.header-auth__actions__me__popover__item{\n    display: flex;\n    align-items: center;\n    padding-top: var(--space);\n    padding-bottom: var(--space-half);\n}\n.header-auth__actions__me__popover__item img{\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    margin-right: var(--space);\n}\n.header-auth__actions__me__popover__item .icon-ball{\n    font-size: 26px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 36px;\n    color: var(--white-color);\n    margin-right: var(--space);\n}\n.header-auth__actions__me__popover__item .baloa-names{\n    color: var(--primary-dark-color);\n    \n}\n.header-auth__actions__me__popover__item .iconb2-exit, .header-auth__actions__me__popover__item .iconb2-settings{\n    font-size: 20px;\n    color: var(--basic-gray-color);\n    margin-right: 10px;\n}\n.header-auth__separator{\n    border-top: 1px solid var(--separator-color);\n}\n\n.header-auth__actions__popover_user .MuiPopover-paper {\n    right: 30px;\n    left: unset !important;\n    top: 70px !important;\n}\n\n.header-auth__actions__popover_notificaciones .MuiPopover-paper {\n    right: 30px;\n    left: unset !important;\n    top: 70px !important;\n}\n\n.header-auth__mobile,\n.header-auth__mobile-actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.header-auth__mobile-menu {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.header-auth__mobile {\n    position: fixed;\n    top: 0;\n    background-color: var(--white-color);\n    width: 100%;\n    padding: 14px 12px;\n    z-index: 2;\n}\n\n.header-auth__mobile-menu {\n    width: 40%;\n}\n\n.header-auth__mobile-actions {\n    width: 60%;\n}\n\n.header-auth__actions__mobile-me img {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n}\n\n.header-auth__actions__mobile-new-post {\n    background-color: var(--new-green-color);\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    padding: 8px;\n    margin: 0;\n    border-radius: 50%;\n    color: var(--white-color);\n}\n\n.header-auth__actions__mobile-me {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.header-auth__mobile-actions .icon-home,\n.header-auth__mobile-actions .icon-trophy,\n.header-auth__mobile-actions .icon-bell-59,\n.header-auth__mobile-actions .hubicon-live_tv1 {\n    font-size: 24px;\n    color: var(--basic-gray-color);\n}\n\n.header-auth__actions__mobile-home.active .hubicon-live_tv-1 {\n    font-size: 24px;\n    color: var(--new-green-color);\n}\n\n.header-auth__mobile-menu .hubicon-menu {\n    font-size: 24px;\n    color: var(--primary-very-dark-color);\n}\n\n.header-auth__actions__mobile-home {\n    display: flex;\n    align-items: center;\n}\n\n.header-auth__mobile-menu .icon-search {\n    font-size: 14px;\n    color: #949F9A;\n    background-color: var(--new-gray-background-color);\n    border-radius: 50%;\n    padding: 6px;\n    margin-left: var(--space);\n    font-weight: bold;\n}\n.header-auth__mobile__search-box {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);\n    padding: 14px 16px;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 4;\n}\n.header-auth__mobile__search-box .icon-arrow-left {\n    font-size: calc( var(--space) + var(--space-half));\n    margin-right: var(--space-and-half);\n}\n.header-auth__mobile__search-box .search-form__form input[type=text] {\n    padding: var(--space-half) var(--space-half) var(--space-half) var(--space-x3)\n }\n.header-auth__mobile__search-box .search-form__form .MuiSvgIcon-root {\n    margin: calc( var(--space-quarter) + 1px );\n}\n.header-auth__actions__mobile-home.active .icon-home,\n.header-auth__actions__mobile-home.active .icon-trophy {\n    color: var(--new-green-color);\n}    \n.header-auth__actions__mobile-me .icon-ball {\n    font-size: 20px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.header-authenticated__baloa-landing {\n    background-color: #EAF7F0;\n    padding: 12px;\n    gap: 8px;\n}\n\n@media screen and ( max-width: 576px ) {\n\n    .header-auth__image {\n        content: url(../../../assets/logos/baloa-logo-icon.svg);\n    }\n\n}\n\n\n@media screen and (max-width: 768px){\n\n  .header-auth__search {\n      width: 24vw !important;\n  }\n\n  .header-auth__actions a.header-auth__actions__home  {\n      margin-left: 15px !important;\n  }\n\n  .header-auth__search form {\n      width: 100% !important;\n  }\n\n  .header-auth__search .search-form__form{\n      margin-left: var(--space-half);\n  }\n\n  .header-auth-link {\n    min-width: unset;\n  }\n\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .header-auth__mobile-menu .hubicon-menu {\n        margin-top: 2px;\n    }\n\n    .header-auth__mobile-menu .icon-search {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
